/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_Insufficient_ShufflingInputs */



/**
* | output |
* | --- |
* | "Insufficient Shuffling" |
*
* @param {Sanction_Sub_Insufficient_ShufflingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_insufficient_shuffling = /** @type {((inputs?: Sanction_Sub_Insufficient_ShufflingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_Insufficient_ShufflingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mélange Insuffisant")
	if (locale === "es") return /** @type {LocalizedString} */ ("Barajado Insuficiente")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Embaralhamento Insuficiente")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mescolamento Insufficiente")
	return /** @type {LocalizedString} */ ("Insufficient Shuffling")
});